module.exports = __webpack_public_path__ + "static/logo1-0fbcb53ea5180befab6b7c1a988beff3.png";